// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.convert {
    width: 100%;
    background: rgba(255, 255, 255, 0.7);
    -webkit-backdrop-filter: blur(41px);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.35);
}

.card_upload .ant-card-body .ant-row {
    row-gap: 10px;
}

.convert__list a {
    display: block;
    padding: 3px 5px;
    border-radius: 5px;
    margin: 1px 0;
}

.convert__list a:hover,
.convert__list a.active {
    font-weight: bold;
    background: linear-gradient(to right, #243B55, #141E30);
}

.convert__list a:hover .ant-badge-status-text,
.convert__list a.active .ant-badge-status-text {
    color: white !important;
}

.ant-upload-drag {
    transition: all .3s ease;
}

.ant-upload-drag:hover {
    transition: all .3s ease;
    border-color: #0ba360 !important;
}

.btn__upload {
    cursor: pointer;
    padding: 0 15px;
    height: 45px;
    min-width: 45px;
    text-align: center;
    border: none;
    column-gap: 10px;
    transition: all .4s ease-in-out;
    background-size: 300% 100%;
    background-image: linear-gradient(to right, #25aae1, #4481eb, #04befe, #3f86ed);
    box-shadow: 0 4px 15px 0 rgba(65, 132, 234, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 10px;
}

.btn__download {
    cursor: pointer;
    padding: 0 15px;
    height: 40px;
    text-align: center;
    border: none;
    column-gap: 10px;
    border-radius: 10px;
    transition: all .4s ease-in-out;
    background-size: 300% 100%;
    background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
    box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}

.btn__download:hover,
.btn__upload:hover {
    text-decoration: none;
    background-position: 100% 0;
    moz-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    color: white;
}

.card_upload {
    margin-top: 10px;
}

.guide__item {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    max-width: 80%;
    text-align: center;
}

@media screen and (max-width: 575px) {
    .guide__item {
        margin-bottom: 30px;
    }
}

@media screen and (max-width: 767px) {
    .convert__list {
        margin-bottom: 20px;
    }

    .convert__list--wrap {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
    }
}

.guide__item p {
    margin: 0;
    padding: 0;
}

.guide__item .title {
    padding: 0;
    margin: 0;
}

.guide__item .img {
    height: 100px;
}

.guide__item .img img {
    width: 100px ;
    height: 100px;
}

.action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    column-gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ConvertFile.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,oCAAoC;IACpC,mCAAmC;IACnC,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;IAEjB,uDAAuD;AAC3D;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,0BAA0B;IAC1B,+EAA+E;IAC/E,iDAAiD;IACjD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,0BAA0B;IAC1B,+EAA+E;IAC/E,iDAAiD;IACjD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;IACrB,2BAA2B;IAC3B,mCAAmC;IAGnC,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,qCAAqC;IACzC;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".convert {\n    width: 100%;\n    background: rgba(255, 255, 255, 0.7);\n    -webkit-backdrop-filter: blur(41px);\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.35);\n}\n\n.card_upload .ant-card-body .ant-row {\n    row-gap: 10px;\n}\n\n.convert__list a {\n    display: block;\n    padding: 3px 5px;\n    border-radius: 5px;\n    margin: 1px 0;\n}\n\n.convert__list a:hover,\n.convert__list a.active {\n    font-weight: bold;\n    background: -webkit-linear-gradient(to right, #243B55, #141E30);\n    background: linear-gradient(to right, #243B55, #141E30);\n}\n\n.convert__list a:hover .ant-badge-status-text,\n.convert__list a.active .ant-badge-status-text {\n    color: white !important;\n}\n\n.ant-upload-drag {\n    transition: all .3s ease;\n}\n\n.ant-upload-drag:hover {\n    transition: all .3s ease;\n    border-color: #0ba360 !important;\n}\n\n.btn__upload {\n    cursor: pointer;\n    padding: 0 15px;\n    height: 45px;\n    min-width: 45px;\n    text-align: center;\n    border: none;\n    column-gap: 10px;\n    transition: all .4s ease-in-out;\n    background-size: 300% 100%;\n    background-image: linear-gradient(to right, #25aae1, #4481eb, #04befe, #3f86ed);\n    box-shadow: 0 4px 15px 0 rgba(65, 132, 234, 0.75);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    border-radius: 10px;\n}\n\n.btn__download {\n    cursor: pointer;\n    padding: 0 15px;\n    height: 40px;\n    text-align: center;\n    border: none;\n    column-gap: 10px;\n    border-radius: 10px;\n    transition: all .4s ease-in-out;\n    background-size: 300% 100%;\n    background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);\n    box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n}\n\n.btn__download:hover,\n.btn__upload:hover {\n    text-decoration: none;\n    background-position: 100% 0;\n    moz-transition: all .4s ease-in-out;\n    -o-transition: all .4s ease-in-out;\n    -webkit-transition: all .4s ease-in-out;\n    transition: all .4s ease-in-out;\n    color: white;\n}\n\n.card_upload {\n    margin-top: 10px;\n}\n\n.guide__item {\n    display: flex;\n    flex-direction: column;\n    row-gap: 20px;\n    max-width: 80%;\n    text-align: center;\n}\n\n@media screen and (max-width: 575px) {\n    .guide__item {\n        margin-bottom: 30px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .convert__list {\n        margin-bottom: 20px;\n    }\n\n    .convert__list--wrap {\n        display: grid;\n        grid-template-columns: repeat(5, 1fr);\n    }\n}\n\n.guide__item p {\n    margin: 0;\n    padding: 0;\n}\n\n.guide__item .title {\n    padding: 0;\n    margin: 0;\n}\n\n.guide__item .img {\n    height: 100px;\n}\n\n.guide__item .img img {\n    width: 100px ;\n    height: 100px;\n}\n\n.action {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    column-gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
